module.exports = __webpack_public_path__ + "img/history-icon.bfc85060.svg";